var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.44 23.89H1.56A1.56 1.56 0 010 22.334v-9.35c0-.858.7-1.557 1.56-1.557h8.766a.52.52 0 110 1.039H1.56a.52.52 0 00-.52.519v9.349a.52.52 0 00.52.519h22.88a.52.52 0 00.52-.52v-9.348a.52.52 0 00-.52-.52h-2.45a.52.52 0 110-1.038h2.45c.86 0 1.56.699 1.56 1.558v9.349c0 .859-.7 1.558-1.56 1.558zm.069-16.664l-1.464 1.462-.001.001-7.671 7.662a.507.507 0 01-.147.098c-.007.003-.01.01-.016.012l-.005.002-5.12 2.192a.515.515 0 01-.573-.11.519.519 0 01-.11-.572l2.194-5.113.003-.006c.002-.006.008-.01.011-.015a.52.52 0 01.099-.148l7.67-7.661.002-.002 1.464-1.461.732-.732a2.576 2.576 0 011.832-.758 2.589 2.589 0 011.832 4.418l-.732.731zm-12.257 6.742l-1.382 3.22 3.225-1.38-1.825-1.822-.018-.018zm.56-.91l2.193 2.191 6.936-6.928-2.193-2.19-6.936 6.928zm8.4-8.39l-.729.728 2.194 2.191.729-.728-2.194-2.191zm3.294-1.098c-.587-.585-1.608-.585-2.194 0l-.364.364 2.193 2.19.365-.364a1.55 1.55 0 000-2.19z",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}

export default SvgEdit;